module.exports = __webpack_public_path__ + "static/4-e7e1821af80558fd88943bef95ada4ef.jpg";